import { ArdoqLoaderComponent, LoaderColor, LoaderSize } from '@ardoq/loader';
import { FlexBox } from '@ardoq/layout';
import styled from 'styled-components';
import { LoadDataNotificationProps } from './PropTypes';

export const LoadDataNotification = ({
  loadingScopeDataNotification,
  loaderColor = LoaderColor.BRAND,
}: LoadDataNotificationProps) => (
  <DisplayDelayed
    justify="center"
    align="center"
    padding="xlarge"
    height="full"
  >
    <ArdoqLoaderComponent
      loaderColor={loaderColor}
      size={LoaderSize.SMALL}
      loaderText={loadingScopeDataNotification}
    />
  </DisplayDelayed>
);

const DisplayDelayed = styled(FlexBox)`
  opacity: 1;
  animation-duration: 1s;
  animation-timing-function: ease-in;
  animation-name: fadeIn;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
